import React from 'react';

const serviceData = [
  {
    category: 'Employee Transportation',
    items: [
      'Daily pick-up and drop for employees across shifts',
      'GPS-tracked cabs with real-time monitoring',
      'Safe night travel with panic button integration',
      'Customized route planning for cost optimization',
    ],
  },
  {
    category: 'Car Rental Services',
    items: [
      'Flexible rental plans – hourly, daily, weekly, monthly',
      'Chauffeur-driven cars with verified professionals',
      'Self-drive options for personal or business use',
      'Luxury cars available for VIP movements',
    ],
  },
  {
    category: 'Shuttle & Bus Services',
    items: [
      'Corporate shuttle programs with fixed routes',
      'AC Buses (26–49 seaters) with on-board safety features',
      'Volvo & luxury coaches for high-end commuting',
      'Real-time tracking and employee boarding reports',
    ],
  },
  {
    category: 'Fleet Management & Logistics',
    items: [
      'Centralized fleet tracking and reporting system',
      'Driver rostering, onboarding & periodic training',
      'Fuel efficiency and route performance analytics',
      '24/7 emergency backup and on-road assistance',
    ],
  },
  {
    category: 'Airport Transfer Services',
    items: [
      'Timely airport pick-up/drop with flight tracking',
      'Meet and greet service for corporate guests',
      'Dedicated airport transfer desk for bulk bookings',
      'Luxury and budget vehicles available 24/7',
    ],
  },
  {
    category: 'Event Transportation',
    items: [
      'Tailored transport plans for corporate events',
      'Logistics for conferences, weddings & group travel',
      'On-site coordinators for smooth execution',
      'Multi-vehicle dispatch and route tracking',
    ],
  },
  {
    category: 'Technology & Safety',
    items: [
      'Driver & vehicle verification with background checks',
      'In-app emergency SOS and alert system',
      'Live trip tracking and ETA sharing',
      'Automated billing & digital documentation',
    ],
  },
  {
    category: 'Sustainable & Eco-friendly Mobility',
    items: [
      'Introduction of EVs (Electric Vehicles) in fleet',
      'Low-emission AC buses for daily commute',
      'Carbon offset partnership for green goals',
      'Employee awareness programs on eco-friendly travel',
    ],
  },
];

const OurServices = () => {
  return (
    <>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1 className="page-heading">Our Services</h1>
        </div>
      </section>

      <section className="our-services-section">
        <div className="container">
          <div className="services-grid">
            {serviceData.map((service, index) => (
              <div className="service-card" key={index}>
                <h4 className="service-title">{service.category}</h4>
                <ul className="service-list">
                  {service.items.map((item, idx) => (
                    <li key={idx}>• {item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurServices;
